export default class CreateContactLocationRequest  {
	locationId: string;
	contactId: string;
}